/**
 * CSK Adversarial Robustness Game — application shell.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */
import { createMonographRouteApp } from "../MonographRouteApp.js";
import { NAVIGATION } from "./data/nav.js";
import { panelTokens } from "@csk/demo-ui";

const advSurfaceTokens = {
  honest: "#34d399",
  adversary: "#f43f5e",
  neutral: "#7d8cab",
  surfaceBound: "#fbbf24",
  interface: "#60a5fa",
};

export const App = createMonographRouteApp({
  navigation: NAVIGATION,
  theme: panelTokens,
  surfaceTokenAliases: [{ prefix: "adv", tokens: advSurfaceTokens }],
  slug: "adversarial-robustness",
  title: "Adversarial Robustness",
  eyebrow: "INTERACTIVE GAME · RD-31",
  tagline:
    "Play the Red Team: compromise up to k of n agents and discover the honest core is unbreachable by construction. The honest-to-honest violation is not blocked — it is structurally inexpressible.",
  companionPath: "research/settled/RD-31-ADVERSARIAL-MULTI-AGENT-ROBUSTNESS.md",
  mainRegionId: "adv-main",
  shortcutsDescription:
    "Keyboard commands for moving across the Adversarial Robustness game.",
  recoveryLabel: "Return to the Red Team board",
  backgroundColor: "#1a0a12",
});
